import styled from 'styled-components';

import { HEADING_MAX_HEIGHT } from '../../../rides/features/PageHeading/constants';
import { colorTokens } from '../variables';

export const CardContainer = styled.div`
  display: flex;
  padding: 20px;
  margin-bottom: ${HEADING_MAX_HEIGHT}px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  gap: 20px;
  align-self: stretch;

  border-radius: 20px;
  border: 1px solid ${colorTokens.primary.disabled};
  background-color: ${colorTokens.background.default};
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 0;
`;
